import { render } from "./AdminX.vue?vue&type=template&id=2238bd7c"
import script from "./AdminX.vue?vue&type=script&lang=js"
export * from "./AdminX.vue?vue&type=script&lang=js"

import "./AdminX.vue?vue&type=style&index=0&id=2238bd7c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__